function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaindrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "svg-container"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    className: "svg-content",
    viewBox: "129.725 16.343 257.406 249.744",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 258.428,
    y1: 27.58,
    x2: 258.428,
    y2: 247.702,
    id: "gradient-0",
    gradientTransform: "matrix(0.999929, -0.011951, 0.00696, 0.582366, -0.173516, 14.6069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgba(85, 149, 218, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(36, 98, 165, 1)"
    }
  }))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 19,
      stroke: "rgb(0, 0, 0)"
    },
    cx: 258.428,
    cy: 137.641,
    rx: 110.061,
    ry: 110.061,
    className: "svg-elem-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 17,
      fill: "none"
    },
    d: "M 280.493 96.326 L 302.719 135.956 C 314.326 157.718 314.895 181.117 307.326 198.908 C 303.497 207.809 297.555 215.483 289.998 220.814 C 282.444 226.144 273.052 229.294 262.512 229.294 C 251.17 229.294 216.787 217.816 208.073 200.379 C 199.497 182.898 200.914 159.105 214.137 134.492 L 257.393 55.134 L 280.493 96.326 Z",
    className: "svg-elem-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286.375 89.614 L 308.687 129.402 C 320.793 153.061 321.509 180.155 313.602 199.713 C 309.229 209.536 301.833 219.004 293.366 225.205 C 284.713 231.092 272.871 235.24 260.98 235.24 C 231.953 235.24 209.22 220.739 198.91 201.569 C 189.907 181.963 191.42 154.242 205.142 127.87 L 255.755 35.014 L 286.375 89.614 Z M 255.967 70.146 L 220.068 136.006 C 207.344 158.86 206.007 178.694 214.156 194.051 C 221.279 209.739 236.365 218.24 260.98 218.24 C 270.169 218.24 277.11 216.088 283.566 211.315 C 290.212 206.855 294.693 200.992 297.978 193.014 C 305.203 176.992 304.795 157.267 293.687 137.402 L 271.547 97.93 L 255.967 70.146 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      paintOrder: "fill"
    },
    className: "svg-elem-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaindrop);
export default __webpack_public_path__ + "static/media/raindrop.2cf74351497f064487182ebd58b3854f.svg";
export { ForwardRef as ReactComponent };